/**
 * @file: WrapRow.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A label-left / wrapping-content-right info row, for chips that won't fit the
 * single right-aligned line a `Field` assumes.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { LD } from '../leadDetailKit';

export const WrapRow = ({
  label,
  children,
  divider = true,
}: {
  label: string;
  children: React.ReactNode;
  divider?: boolean;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: rpx(44),
        borderTopWidth: divider ? 1 : 0,
        borderTopColor: LD.hairline,
      }}
    >
      <Typography.Text
        size={rpx(13)}
        color={LD.steel}
        style={{ marginRight: rpx(12) }}
      >
        {label}
      </Typography.Text>
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
        }}
      >
        {children}
      </View>
    </View>
  );
};
